import api from '../api';

const MAX_FILE_SIZE_MB = 8;

/**
 * Uploads a single file to Firebase Storage via signed URL returned by backend
 * @param {File} file
 * @param {'User'|'UserVehicle'|'Trip'|'TripStep'} domain
 */
export async function uploadImage(file, domain) {
    if (!file) return null;

    // File size check
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        alert(`Images uploaded must be less than ${MAX_FILE_SIZE_MB}MB`);
        return;
    }

    // Request signed URL from backend
    const { uploadUrl, publicUrl } = (await api.post("/image/signed-upload-url", {
        FileName: file.name,
        ContentType: file.type,
        ImageDomain: domain
    })).data;

    // Upload directly to Firebase Storage
    fetch(uploadUrl, {
        method: "PUT",
        body: file,
    });

    // Return public URL for optimistic update
    return publicUrl;
}

/**
 * Uploads user profile + vehicle images concurrently
 * Returns { profileImageUrl, vehicleImageUrl }
 */
export async function updateUserImages(profileImage, vehicleImage) {
  const safeUpload = async (file, domain) => {
    try {
      const url = await uploadImage(file, domain);
      return { success: true, url };
    } catch (err) {
      console.error(`Upload failed for ${domain}:`, err);
      return { success: false, url: null, error: err.message || err };
    }
  };

  const uploads = {
    profile: profileImage ? safeUpload(profileImage, "User") : null,
    vehicle: vehicleImage ? safeUpload(vehicleImage, "UserVehicle") : null,
  };

  const [profileResult, vehicleResult] = await Promise.all([
    uploads.profile,
    uploads.vehicle
  ]);

  return {
    profileImageUrl: profileResult?.url || null,
    profileImageError: profileResult?.success ? null : profileResult?.error,
    vehicleImageUrl: vehicleResult?.url || null,
    vehicleImageError: vehicleResult?.success ? null : vehicleResult?.error
  };
}

